import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestFoldersPut = {
    path: "/folders/:id",
    method: RouteHttpVerb.PUT
};
export { locationRestFoldersPut };
